import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";
import { SidebarProvider, useSidebar } from "../contexts/SidebarContext";

function EntryPageContent() {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname.split("/")[2];
  const { isCollapsed } = useSidebar();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen flex">
      <div className={`z-30 fixed top-0 hidden lg:block transition-all duration-300 ${isCollapsed ? 'w-20' : 'w-72'}`}>
        <div className="h-screen shadow-r-xl bg-gradient-to-t bg-[#303641] border-r">
          <div className="h-[calc(100vh)] overflow-y-scroll">
            <NavBar />
          </div>
        </div>
      </div>

      <div className={`w-full bg-slate-300 transition-all duration-300 ${isCollapsed ? 'lg:ml-20' : 'lg:ml-72'}`}>
        <div className="sticky z-30 top-0">
          <Header />
        </div>
        <div className="pt-1 rounded-xl min-h-screen z-10 text-gray-600">{<Outlet />}</div>
        {pathname !== "grievancesMsgs" && (
          <div className="px-4 py-4 border-t-[0.1px] text-xs text-slate-900 mx-4 border-gray-400">
            COPYRIGHT - BRAVISHMAH INFOTECH PRIVATE LIMITED
          </div>
        )}
      </div>
    </div>
  );
}

export default function EntryPage() {
  return (
    <SidebarProvider>
      <EntryPageContent />
    </SidebarProvider>
  );
}
